import { render, staticRenderFns } from "./SoftwareUpdates.vue?vue&type=template&id=bcf5e0aa&scoped=true"
import script from "./SoftwareUpdates.vue?vue&type=script&lang=js"
export * from "./SoftwareUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf5e0aa",
  null
  
)

export default component.exports